__turbopack_context__.v({
  "funnel-step": "hE0DkW_funnel-step",
  "input-spacing": "hE0DkW_input-spacing",
  "placeholder": "hE0DkW_placeholder",
});
